import React from 'react';
import cx from 'classnames';
import { isNil } from 'lodash';
import './TableColumnTitle.scss';

const TableColumnTitle = (props) => {
  const { className, title, filterValue } = props;

  return (
    <div className={cx('table-column-title', className)}>
      <span>{title}</span>

      {!isNil(filterValue) ? (
        <div className="filter-value">
          <span>검색:</span>
          {filterValue}
        </div>
      ) : null}
    </div>
  );
};

export default TableColumnTitle;
